import React, { memo } from "react";
import { styled } from "styled-components";

type Asset = "cart" | "search";

interface Props extends React.SVGProps<SVGSVGElement> {
  asset: Asset;
  color?: string;
  size?: number;
}


const SvgIcon = memo(
  ({ asset, color = "currentColor", onClick, className, size, ...rest }: Props) => {
    const mainColor = color;

    const Svg = (props: React.SVGProps<SVGSVGElement>) => (
      <StyledSvg
        clickable={Boolean(onClick)}
        onClick={onClick}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role={onClick ? "button" : "none"}
        {...props}
        {...rest}
        {...(size
          ? {
            width: size,
            height: size,
            style: { ...(rest.style ?? {}), minWidth: `${size}px` },
          }
          : {})}
      />
    );


    if (asset === "cart") {
      return (
        <Svg width="24" height="24" viewBox="0 0 17 17" fill="none">
          <path d="M16.4948 2.50398C16.4039 2.38731 16.2664 2.3194 16.1209 2.3194H3.37675L3.02037 0.733083C2.97021 0.509906 2.77676 0.351807 2.55379 0.351807H0.47883C0.214402 0.351807 0 0.572053 0 0.843723C0 1.11539 0.214402 1.33561 0.47883 1.33561H2.17288L4.5919 12.1038C4.64202 12.327 4.83551 12.4851 5.05847 12.4851H14.6524C14.9169 12.4851 15.1313 12.2649 15.1313 11.9932C15.1313 11.7216 14.9169 11.5014 14.6524 11.5014H5.43942L5.07112 9.86171H14.6844C14.9084 9.86171 15.1024 9.70224 15.1516 9.4778L16.588 2.91926C16.62 2.77345 16.5857 2.62068 16.4948 2.50398ZM14.3013 8.87791H4.8501L3.59776 3.30317H15.5223L14.3013 8.87791Z" fill={mainColor} />
          <path d="M7.02332 13.1414C6.05522 13.1414 5.26758 13.9504 5.26758 14.945C5.26758 15.9395 6.05519 16.7486 7.02332 16.7486C7.99141 16.7486 8.77905 15.9395 8.77905 14.945C8.77905 13.9504 7.99144 13.1414 7.02332 13.1414ZM7.02332 15.7648C6.58326 15.7648 6.22527 15.397 6.22527 14.945C6.22527 14.4929 6.58326 14.1252 7.02332 14.1252C7.46337 14.1252 7.82136 14.4929 7.82136 14.945C7.82136 15.397 7.46337 15.7648 7.02332 15.7648Z" fill={mainColor} />
          <path d="M12.7694 13.1414C11.8013 13.1414 11.0137 13.9504 11.0137 14.945C11.0137 15.9395 11.8013 16.7486 12.7694 16.7486C13.7375 16.7486 14.5251 15.9395 14.5251 14.945C14.5251 13.9504 13.7375 13.1414 12.7694 13.1414ZM12.7694 15.7648C12.3294 15.7648 11.9714 15.3971 11.9714 14.945C11.9714 14.493 12.3294 14.1252 12.7694 14.1252C13.2095 14.1252 13.5675 14.493 13.5675 14.945C13.5675 15.3971 13.2095 15.7648 12.7694 15.7648Z" fill={mainColor} />
        </Svg>
      )
    }

    if (asset === "search")
      return (
        <Svg width="24" height="24" viewBox="0 0 15 15" fill="none" >
          <path d="M14.8497 13.6746L9.51301 8.75842C11.3875 6.64656 11.0486 3.53477 8.75606 1.80802C6.46356 0.0812756 3.08555 0.393488 1.21108 2.50532C-0.663385 4.61716 -0.324464 7.72897 1.96803 9.45572C3.94268 10.943 6.78141 10.943 8.75606 9.45572L14.0928 14.3719C14.3055 14.5611 14.6444 14.5557 14.8497 14.3598C15.0501 14.1686 15.0501 13.8657 14.8497 13.6746ZM5.37061 9.58491C3.00647 9.58246 1.0906 7.81759 1.08797 5.63976C1.08797 3.46092 3.00537 1.69461 5.37061 1.69461C7.73584 1.69461 9.65325 3.46092 9.65325 5.63976C9.65325 7.81861 7.73584 9.58491 5.37061 9.58491Z" fill={mainColor} />
        </Svg>

      );

    return null;
  },
  (prev, next) =>
    prev["aria-expanded"] === next["aria-expanded"] &&
    prev.size === next.size &&
    prev.asset === next.asset &&
    prev.color === next.color
);

export default SvgIcon;

const StyledSvg = styled.svg<{ clickable?: boolean }>`
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "inherit")};
`;